import {
  Button,
  DisplayOn,
  IconButton,
  skeletonize,
} from "@songtradr-one/components-frontend";
import { text } from "./ExportButton.Parts";

const ButtonSkeleton = skeletonize(Button);
const IconButtonSkeleton = skeletonize(IconButton);

export const ExportButtonSkeleton = () => (
  <>
    <DisplayOn mobile>
      <IconButtonSkeleton />
    </DisplayOn>

    <DisplayOn desktop>
      <ButtonSkeleton disabled>{text.label}</ButtonSkeleton>
    </DisplayOn>
  </>
);
